@use "../../../../../scss/settings/colors";

.table_container {
  box-shadow: none;
  border-radius: 8px;
  background-color: colors.$base-white !important;
}

.empty_message {
  max-width: 228px;
  margin-left: auto;
  margin-right: auto;
  font-family: "Light Inter", sans-serif;
  font-style: italic;
  font-size: 0.875rem;
  line-height: 1.3125rem;
  text-align: center;
  color: colors.$dark-blue;
}

.profile_container,
.file_type_container,
.date_container {
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    fill: colors.$dark-blue;;
  }

}

.profile_icon,
.file_type_icon {
  display: flex;
  align-items: center;
  color: colors.$dark-blue;

  svg {
    fill: colors.$dark-blue;
  }

  .MuiSvgIcon-root {
    width: 24px !important;
    height: 24px !important;
  }

}

.profile_icon {
  width: 24px;
  height: 24px;
  justify-content: center;
}


.actions_container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-left: 8px;

  .action_button {
    flex-shrink: 0;

    svg {
      fill: colors.$dark-blue !important;
    }


    &:hover {

      svg {
        fill: colors.$dark-blue !important;
      }

    }

  }

}

.header_cell {
  &.actions_header {
    text-align: right;
    padding-left: 24px;
  }
}

.badge_new {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 45px;
  height: 20px;
  font-family: "Medium Inter", sans-serif;
  font-size: 12px;
  color: colors.$text-black-4;
  background-color: colors.$blue-variant-2;
  border-radius: 4px;
}

.table_row {
  border-bottom: 1px solid colors.$gray-variant-4;
  transition: border-color 0.3s;
  cursor: pointer;

  &.doc_new {

    td {
      border-color: colors.$brand-purple;

      &:first-child {
        border-left: 1px solid colors.$brand-purple;
      }

      &:last-child {
        border-right: 1px solid colors.$brand-purple;
      }

    }

    &:first-child {

      td {
        border-top: 1px solid colors.$brand-purple;
      }

    }

  }

}

.table_cell {
  padding: 16px;

  .cell_text {
    color: colors.$dark-blue;
  }

}

.profile_text {
  min-width: 100px;
  max-width: 150px;
  color: colors.$dark-blue;
}

.file_name_container {
  width: 295px;
  color: colors.$dark-blue;
}

.header_text {
  color: colors.$dark-blue;
}

.file_type_chip {
  border-radius: 16px;
  padding: 2px 8px;
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
}

.date_container {
  display: flex;
  align-items: center;
  gap: 4px;

  .cell_text {
    white-space: nowrap;
  }

}

.green_label, .blue_label {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  font-family: 'Medium Inter', sans-serif;
  font-size: 12px;
  color: colors.$text-black;
  background-color: colors.$green-variant-light;
  border-radius: 4px;
}

.blue_label {
  background-color: colors.$blue-variant-2;
}